import React from 'react'

import { blueTextColor, lightBlueBackground } from '../../../../lib/styles/colors'
import Banner from '../Banner'

type InfoBannerProps = {
  /** Content to display in the info banner */
  children: React.ReactNode
  /** Optional className to apply to the banner */
  className?: string
  /** Whether this banner can be dismissed */
  dismissable?: boolean
  /** Optional icon to display on the banner */
  icon?: React.ReactNode
  /** Callback event for the dismiss click */
  onDismiss?: () => void
}

const defaultProps = {
  className: undefined,
  dismissable: false,
  icon: undefined,
  onDismiss: undefined
}

const InfoBanner = ({ children, className, dismissable, icon, onDismiss }: InfoBannerProps) => (
  <Banner
    backgroundColor={lightBlueBackground}
    className={className}
    dismissable={dismissable}
    icon={icon}
    iconColor={blueTextColor}
    onDismiss={onDismiss}
  >
    {children}
  </Banner>
)

InfoBanner.defaultProps = defaultProps

export default InfoBanner
